import React, { Component } from 'react';

class GroupBox extends Component {
    render() {
        return (
            <div style={{
                padding: '1rem', border: '1px solid ' + (this.props.borderColor ?? '#80808040'),
                borderRadius: '1rem', marginTop: '1.5rem', /*display: 'inline-flex',*/ ...this.props.style, position: 'relative',
            }}>
                {this.props.children}
                <div style={{
                    position: 'absolute', top: '-0.6rem', padding: '0.1rem 1rem',
                    background: this.props.titleColor ?? 'khaki',
                    borderRadius: '0.5rem',
                    ...this.props.titleStyle,
                    right: this.props.titleAlign == 'right' ? '3rem' : (this.props.titleAlign ?? 'center') == 'center' ? 'calc(50% - 3rem)' : undefined,
                    left: this.props.titleAlign == 'left' ? '3rem' : undefined,
                }}>
                    {this.props.title}
                </div>
            </div>
        );
    }
}

export default GroupBox;